<template>
    <div>
        <view-item v-if="!!template" :item="template" @success="alertSuccess" @delete-item="deleteType"
            @cancel="cancelTemplate" @error="showError"></view-item>

        <list-items v-else title="RPA Templates" @show-item="showItem" ref="table">
            <b-button id="add-rpa-template-btn" block variant="primary" v-if="hasPermissionCreate"
                @click="addTemplate"><img v-b-tooltip.hover :title="$addLabel()"
                    src="@/assets/images/icon/blue-add.svg" /></b-button>
        </list-items>
    </div>
</template>http://localhost:8080/#
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import errorHandlingMixins from '@/mixins/errorHandlingMixins'

import ListItems from './ListItems'
import ViewItem from './ViewItem'

export default {
    name: 'RpaTemplates',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [
        popupMixins,
        utilityMixins,
        permissionsMixins,
        errorHandlingMixins,
    ],
    data: () => {
        return {

        }
    },
    mounted() {
        this.$store.dispatch('rpaTemplate/getOptions')
    },
    computed: {
        componentName() {
            return this.$translate('rpa_templates')
        },
        templates() {
            return this.$store.state.rpaTemplate.templates || []
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
        template() {
            return this.$store.state.rpaTemplate.template
        },
    },

    methods: {
        async doSearch() {
            await this.$store.dispatch('rpaTemplate/fetchAll', {})
        },

        showItem(id) {
            this.$store.dispatch('rpaTemplate/fetchById', id);
        },

        addTemplate() {
            this.$store.commit('rpaTemplate/set_template', {});
        },

        cancelTemplate() {
            this.$store.commit('rpaTemplate/set_template');
        },

        alertSuccess(action, message) {
            console.log(this.template)
            this.genericToast(
                this.componentName,
                this.$translate(`${action}d`),
                'success',
                `${this.componentName
                } ${message}`
            )
            this.cancelTemplate();
            this.doSearch()
        },

        showError(error) {
            this.genericToast(
                this.componentName,
                'Error',
                'danger',
                `${error.message}`
            )

        },
    },
}
</script>
<style></style>
